var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPharmacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 85,
    viewBox: "0 0 62 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8574 26.4806L61.6657 66.2815L61.6338 73.9797C61.6018 80.0968 55.7882 85.0319 48.633 85L12.8889 84.8403C5.74971 84.7924 -0.0319427 79.8093 1.18176e-07 73.6762L0.2236 26.1772C0.239572 21.226 4.07271 17.0415 9.31134 15.652L9.32732 13.0966V11.7869L52.8814 11.9946L52.8654 15.8596C58.0881 17.313 61.8733 21.5135 61.8574 26.4806Z",
    fill: "url(#paint0_linear_27_36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1236 1.77283V2.1242L56.0917 6.27678L56.0598 10.3495V10.8446C56.0598 11.6112 55.4209 12.2341 54.6543 12.2341H54.3189L52.2106 12.2182L49.8948 12.2022L47.7866 12.1862L45.4707 12.1702L43.3305 12.1383L41.0147 12.1223L38.9064 12.1064L36.5746 12.0904L34.4504 12.0744L32.1345 12.0584L30.0263 12.0265L27.7105 12.0105L25.6022 11.9945L23.2704 11.9786L21.1462 11.9626L18.8463 11.9466L16.7381 11.9307L14.4222 11.9147L12.298 11.8987L9.98216 11.8828L7.85795 11.8668H7.52255C6.75593 11.8668 6.13304 11.2279 6.13304 10.4613V10.4453V10.0939L6.19692 1.88463V1.38952C6.19692 0.622886 6.83578 0 7.61838 0H7.95378L12.3938 0.0319429L16.8339 0.0638858L18.9581 0.0798572L21.274 0.0958286L23.3822 0.1118L27.8063 0.159714L30.1221 0.175686L32.2304 0.191657L34.5462 0.207629L36.6545 0.2236L38.9703 0.239572L41.0786 0.255543L43.3944 0.271514L45.5026 0.287486L47.8504 0.319429L49.9587 0.3354L52.2745 0.351372L54.3987 0.367343H54.7341C55.5167 0.383315 56.1236 1.0062 56.1236 1.77283Z",
    fill: "url(#paint1_linear_27_36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1236 2.14019L56.0917 6.27679L56.0598 10.3495L54.1592 10.3335L51.6357 10.3176L49.3198 10.3016H46.7804L44.4645 10.2856L41.941 10.2697L39.6251 10.2537H37.0857L34.7698 10.2377L32.2304 10.2217L29.9305 10.2058H27.391L25.0752 10.1898L22.5357 10.1738L20.2198 10.1579H17.6964L15.3805 10.1419L12.841 10.1259L10.5252 10.1099H8.0017L6.13304 10.094L6.19692 1.88464L10.637 1.90061L15.4763 1.93256L17.7922 1.94853L20.3316 1.9645H22.6475L27.4869 1.99644L30.0263 2.01242H32.3422L34.8816 2.02839L37.1815 2.04436L39.721 2.06033H42.0368L44.5763 2.0763L46.8762 2.09227L49.4156 2.10824H51.7315L54.271 2.12422L56.1236 2.14019Z",
    fill: "url(#paint2_linear_27_36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8105 34.8841L0.176762 34.5927L0.0475271 61.9198L61.6813 62.2112L61.8105 34.8841Z",
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8215 34.884L0.18766 34.5927L0.164404 39.5119L61.7982 39.8032L61.8215 34.884Z",
    fill: "#FBFCF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2127 45.5803L20.2358 45.5644L20.2518 41.5715L14.7736 41.5555L14.7576 45.5324L10.7807 45.5165L10.7488 50.9787L14.7257 50.9947L14.7097 54.9875L20.1879 55.0035L20.2039 51.0266L24.1808 51.0426L24.2127 45.5803Z",
    fill: "url(#paint3_linear_27_36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2364 46.906L31.5276 46.8102C31.0006 46.8102 30.5693 46.379 30.5693 45.8519V45.4047C30.5693 44.8776 31.0006 44.4464 31.5276 44.4464L51.2364 44.5422C51.7634 44.5422 52.1947 44.9735 52.1947 45.5005V45.9477C52.1947 46.4748 51.7634 46.906 51.2364 46.906Z",
    fill: "url(#paint4_linear_27_36)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.2204 52.7675L31.5116 52.6717C30.9846 52.6717 30.5534 52.2405 30.5534 51.7134V51.2662C30.5534 50.7392 30.9846 50.3079 31.5116 50.3079L51.2204 50.4038C51.7475 50.4038 52.1787 50.835 52.1787 51.362V51.8092C52.1787 52.3363 51.7475 52.7675 51.2204 52.7675Z",
    fill: "url(#paint5_linear_27_36)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M6.13304 1.77286V2.12423L6.16498 6.2768L6.19692 10.3335V10.8287C6.19692 11.5953 6.83578 12.2182 7.60241 12.2182H7.93781L10.062 12.2022L12.3779 12.1862L14.4861 12.1703L16.802 12.1543L18.9102 12.1383L21.226 12.1223L23.3343 12.1064L25.6501 12.0904L27.7743 12.0744L30.0902 12.0585L32.1984 12.0425L34.5143 12.0265L36.6225 12.0105L38.9384 11.9946L41.0626 11.9786L43.3784 11.9626L45.4867 11.9467L47.8025 11.9307L49.9108 11.9147L52.2266 11.8987L54.3508 11.8828H54.6862C55.4528 11.8828 56.0757 11.2439 56.0757 10.4773V10.4613V10.1099C31.3679 11.18 7.52255 0.367371 7.52255 0.367371C6.75593 0.383342 6.13304 1.00623 6.13304 1.77286Z",
    fill: "#1A6FB5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_36",
    x1: -2.08595e-7,
    y1: 11.3333,
    x2: 57.1389,
    y2: 90.1944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_36",
    x1: -629.93,
    y1: -39.931,
    x2: -27.6041,
    y2: 2.02206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0525488,
    stopColor: "#A9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2879,
    stopColor: "#8DE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5247,
    stopColor: "#79E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7618,
    stopColor: "#6DDDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_36",
    x1: 6.13994,
    y1: 6.11313,
    x2: 56.1258,
    y2: 6.11313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0525488,
    stopColor: "#A9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2879,
    stopColor: "#8DE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5247,
    stopColor: "#79E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7618,
    stopColor: "#6DDDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27_36",
    x1: 21.9779,
    y1: 43.0953,
    x2: 12.5975,
    y2: 53.9124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_36",
    x1: 52.3847,
    y1: 45.671,
    x2: 28.8866,
    y2: 45.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27_36",
    x1: 30.5519,
    y1: 51.5322,
    x2: 52.179,
    y2: 51.5322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.8574,
    height: 85,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.7d6b458c70906b54a471775359360f9a.svg";
export { ForwardRef as ReactComponent };